<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading" class="flex flex-col h-screen overflow-hidden min-h-0">
    <div class="flex flex-row cursor-pointer flex-shrink-0">
        <p (click)="goBack()"
            class="font-semibold text-[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-[#0F0F0F] text-l">Profile</p>
        <p class="font-semibold text-[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-[#0F0F0F] text-l">View My
            Target
        </p>
    </div>


    <div class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg flex flex-col flex-1 min-h-0 overflow-hidden">
        <div class="flex-shrink-0">
        <div class="flex flex-row items-center justify-between">
            <div class="flex flex-col justify-between gap-3">
                <p class="font-semibold text-lg mb-1 dark:text-white">Current Active Target</p>
                <p *ngIf="hasData" class="font-semibold text-lg mb-1 dark:text-white">EMP ID :
                    {{officerDataArr[0].empId}}</p>
            </div>
            <div class="flex flex-row items-center gap-8 ">
                <i class="fa-solid text-[#4A4A4A] fa-list text-lg dark:text-white"></i>

                <p class="text-[#4A4A4A] dark:text-white">Filter By</p>


                <div class="relative w-44 custom-role-dropdown-container">
                    <!-- Hidden native select -->
                    <select [(ngModel)]="selectStatus" class="hidden" (change)="filterStatus()">
                        <option value="" selected disabled>Status</option>
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Pending">Pending</option>
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Completed">Completed</option>
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Exceeded">Exceeded</option>
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Extra">Extra</option>
                    </select>

                    <!-- Custom dropdown trigger -->
                    <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                        (click)="toggleStatusDropdown()">
                        <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                            <span>{{ selectStatus || 'Status' }}</span>
                            <div class="flex items-center">
                                <i *ngIf="selectStatus" (click)="cancelStatus($event)"
                                    class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>
                                <i *ngIf="iStatusDropdownOpen || !selectStatus"
                                    class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                    [class.fa-angle-down]="!iStatusDropdownOpen"
                                    [class.fa-angle-up]="iStatusDropdownOpen"></i>
                            </div>
                        </div>
                    </div>

                    <!-- Custom dropdown options -->
                    <div *ngIf="iStatusDropdownOpen"
                        class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                        <div *ngFor="let option of statusDropdownOptions" (click)="selectStatusOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center">
                            <span class="flex-grow">{{ option }}</span>
                        </div>
                    </div>
                </div>


                <div class="flex mr-5 items-center rounded-full  px-4 py-2 w-96 bg-[#F1F1F1] dark:bg-[#4B5563]">
                    <input type="text" placeholder="Search by Crop / Variety name.." [(ngModel)]="searchText"
                        (keydown.enter)="onSearch()" (keydown.esc)="offSearch()"
                        class="bg-transparent outline-none w-full text-textLight dark:text-textDark" />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

            </div>

        </div>
        </div>

        <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen mt-6">
            <p class="text-[#494949] my-6 dark:text-white">--No Data Available--</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
        </div>

        <div *ngIf="hasData" class="mt-5 mr-5 relative flex-1 min-h-0">
        <div class="border-gray-100 border-[2px] rounded-lg dark:border-[#202021] overflow-auto h-full"
            #tableContainer>
            <table class="w-full min-w-max divide-y-2 overflow-hidden">
                <thead class=" text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021]">
                    <tr>
                        <th class="px-6 py-3 text-left font-semibold">No</th>
                        <th class="px-6 py-3 text-left font-semibold">Crop Name</th>
                        <th class="px-6 py-3 text-left font-semibold">Variety Name</th>
                        <th class="px-6 py-3 text-left font-semibold">Grade</th>
                        <th class="px-6 py-3 text-left font-semibold">Target (kg)</th>
                        <th class="px-6 py-3 text-center font-semibold">To Do (kg)</th>
                        <th class="px-6 py-3 text-left font-semibold">Completed (kg)</th>
                        <th class="px-6 py-3 text-center font-semibold">Status</th>
                        <!-- <th class="px-6 py-3 text-left font-semibold">Ends At</th> -->
                        <th class="px-6 py-3 text-left font-semibold"></th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                    <tr *ngFor="let item of officerDataArr; let i = index">
                        <td class="px-6 py-4 text-[#000000] font-semibold dark:text-textDark">
                            {{ (i + 1) < 10 ? '0' + (i + 1) : (i + 1) }} </td>
                        <td class="px-6 py-4 text-black font-semibold dark:text-gray-300">{{item.cropNameEnglish}}</td>
                        <td class="px-6 py-4 text-black font-semibold dark:text-gray-300">{{item.varietyNameEnglish}}
                        </td>
                        <td class="px-6 py-4 text-black text-center font-semibold dark:text-gray-300">{{item.grade}}
                        </td>
                        <td class="px-6 py-4 text-black font-semibold dark:text-gray-300">{{item.target}}</td>
                        <td class="px-6 py-4 text-black font-semibold dark:text-gray-300">{{item.remaining}}</td>
                        <td class="px-6 py-4 text-black font-semibold dark:text-gray-300">{{item.complete}}</td>
                        <td class="px-6 py-4 text-black font-semibold dark:text-gray-300 ">
                            <div class="flex justify-center items-center">
                                <span *ngIf="item.status === 'Pending'"
                                    class="bg-[#F8FFA6] min-w-28 text-[#A8A100] text-center rounded-lg px-6 py-1 ">
                                    Pending
                                </span>
                                <span *ngIf="item.status === 'Completed'"
                                    class="bg-[#B7FFBE] min-w-28 text-[#02BB3D] text-center rounded-lg px-4 py-1 ">
                                    Completed
                                </span>
                                <span *ngIf="item.status === 'Exceeded'"
                                    class="bg-[#C8E0FF] min-w-28 text-[#415CFF] text-center rounded-lg px-5 py-1 ">
                                    Exceeded
                                </span>
                                <span *ngIf="item.status === 'Extra'"
                                    class="bg-[#FFE4C9] min-w-28 text-[#CD6700] text-center rounded-lg px-5 py-1 ">
                                    Extra
                                </span>
                            </div>

                        </td>

                        <td class="px-6 py-4 text-gray-900 dark:text-gray-300">
                            <i *ngIf="item.status === 'Pending'"
                                class="fa-solid fa-pen-to-square text-blue-600 cursor-pointer text-xl"
                                (click)="navigateToNewPage(item.id)">
                            </i>
                            <i *ngIf="item.status !== 'Pending'"
                                class="fa-solid fa-pen-to-square text-xl text-gray-400">
                            </i>
                        </td>
                    </tr>
                </tbody>

            </table>
        </div>
        </div>
        <div *ngIf="hasData" class="flex-shrink-0 flex items-center justify-center text-center mt-6">
            <button
                class="bg-[#415CFF] text-white text-center shadow-md font-medium rounded-lg py-2 px-5 mr-5 text-lg flex items-center"
                (click)="downloadTemplate1()">
                <i class="fa-solid fa-download px-2" *ngIf="!isDownloading"></i>
                <i class="fa-solid fa-spinner fa-spin px-2" *ngIf="isDownloading"></i>
                {{ isDownloading ? " Downloading..." : " Download" }}
            </button>
        </div>
    </div>
</div>